import { useApi } from "./useApi";
import { useStoreSelector } from "./redux/useStoreSelector";
import { useCallback, useEffect } from "react";
import { useFetching } from "./system/useFetching";
import { dispatcher } from "../store";

export function useTradableAssets(isLazy: boolean = false, isGlobal: boolean = true) {
  const { api, isAuth } = useApi(),
    { local, withFetching } = useFetching(isGlobal),
    tradableAssets = useStoreSelector(s => s.tradableAssets.list);

  const loadTradableAssets = useCallback(
    async () => {
      if (isAuth) {
        const res = await withFetching(api.getTradableAssets({}));
        if (res.status === 200) {
          dispatcher.tradableAssets.setList(res.body)
        }
      }
    },
    [api, isAuth, withFetching]
  );

  useEffect(() => {
    if (!tradableAssets && !local && !isLazy) {
        loadTradableAssets()
    }
  }, [tradableAssets, isLazy, loadTradableAssets, local]);

  return { tradableAssets, loadTradableAssets };
}
